import { useCallback, useMemo, useState } from "react";
import ImeiContext from "./imei-context";

interface Props {
  children: React.ReactNode;
}

const ImeiProvider = ({ children }: Props) => {
  const [imei, setImei] = useState<string>();

  const updateImei = useCallback((newImei: string) => setImei(newImei), []);

  const imeiContext = useMemo(
    () => ({
      imei,
      updateImei,
    }),
    [imei, updateImei]
  );

  return <ImeiContext.Provider value={imeiContext}>{children}</ImeiContext.Provider>;
};
export default ImeiProvider;
